import { Routes } from '@angular/router';
import { CodeLoginComponent } from './components/code-login/code-login.component';
import { AddPaymentCardComponent } from './components/add-payment-card/add-payment-card.component';
import { BiometricVerificationComponent } from './components/biometric-verification/biometric-verification.component';
import { SummaryComponent } from './components/summary/summary.component';
import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  { path: 'add-card', component: AddPaymentCardComponent, canActivate: [authGuard] },
  { path: 'biometric-check', component: BiometricVerificationComponent, canActivate: [authGuard] },
  { path: 'summary', component: SummaryComponent },
  { path: ':code', component: CodeLoginComponent },
  { path: '**', redirectTo: '' }
];
